<template>
    <div class="slider slider2 ">
        <div class="title"></div>
        <div class="cnt">
            <div class="position-relative w100 h100">
                <div class="reg">
                    <regLogin :isEventPageLogin="false" @handleInfoAgain="handleInfoAgain" :box2Login="box2Login"/>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import regLogin from '../publicComponents/regLogin.vue'
export default {
    props: ["onNext", "logged"],
    components: {
        regLogin
    },
    created() {
    },
    mounted() {
    },
    watch: {
        // 监听到父组件传递过来的数据后，加工一下，
        // 存到data中去，然后在页面上使用
        logged(newVal, oldVal) {
           this.box2Login = newVal

        },
       
    },
    data() {
        return {
           box2Login: false
        };
    },

    methods: {
        // 登陆成功后，再次走info
        handleInfoAgain(isNew) {

            this.$emit('handleSilder2Login',isNew)
        },
    },
};
</script>
<style lang="scss" scoped>
.slider2 {
    background: url("../../assets/img/m2/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    // height: 1080px;
    height: 100%;
    position: relative;

    // margin: 60px auto 30px auto;
    // padding-top: 45px;
   
    z-index: 9;

    .title {
        background: url("../../assets/img/m2/title.png") no-repeat top;
        background-size: 100% 100%;
        width: 703px;
        height: 68px;
        // margin: 0 auto;
        position: absolute;
        left: 50%;
        top: 35px;
        transform: translate(-50%, 0);
    }

    .cnt {
        background: url("../../assets/img/m2/cnt-bg.png") no-repeat top;
        background-size: 100% 100%;
        width: 1338px;
        height: 796px;
        position: absolute;
        left: 349px;
        top: 100px;

        .reg {
            background: url("../../assets/img/common/login/m2-login-bg.png") no-repeat top;
            background-size: 100% 100%;
            width: 670px;
            height: 466px;
            position: absolute;
            bottom: 45px;
            left: 0;

        }

    }
}


@media screen and (min-width: 2560px) and (max-width: 3440px) {
    // .slider2 {
    //     margin-top: 20px !important;
    // }
    .title {
        width: 728px !important;
        height: 58px !important; 
        top: 20px  !important;
    }

    .cnt {
        width: 1180px !important;
        height: 677px !important;
        left: 297px !important;

        .reg {
            width: 570px !important;
            height: 396px !important;

            bottom: 70px !important;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider2.vue